/**
 * src/components/analytics/TikTokPixel.jsx
 *
 * TikTok Pixel. Captura PageView para audiencias + lookalike + optimización
 * de campañas en TikTok Ads Manager.
 *
 * Activación: setear NEXT_PUBLIC_TIKTOK_PIXEL_ID en Vercel (formato
 * C4XXXXXXXXXXXXXXX, ~20 chars alfanuméricos).
 *
 * Consent gate: respeta el opt-in de marketing del CookieConsentBanner.
 *
 * Conversión CompletePayment: server-side via Events API desde el webhook
 * de Stripe. Ver src/lib/capi.js. El client-side queda solo para PageView.
 *
 * Verificación: TikTok Pixel Helper (extensión Chrome) → debería mostrar
 * "Pixel ID: C4XX..." en verde cuando entrás al site.
 */

'use client';

import Script from 'next/script';
import { useMarketingConsent } from '@/lib/cookie-consent';

export default function TikTokPixel() {
  const pixelId = process.env.NEXT_PUBLIC_TIKTOK_PIXEL_ID;
  const consentGranted = useMarketingConsent();

  if (!pixelId) return null;
  if (!consentGranted) return null;

  return (
    // PERF (auditoría PageSpeed 2026-07-03): lazyOnload — ver MetaPixel.jsx.
    <Script id="tiktok-pixel-init" strategy="lazyOnload">
      {`
        !function (w, d, t) {
          w.TiktokAnalyticsObject=t;
          var ttq=w[t]=w[t]||[];
          ttq.methods=["page","track","identify","instances","debug","on","off","once","ready","alias","group","enableCookie","disableCookie","holdConsent","revokeConsent","grantConsent"];
          ttq.setAndDefer=function(t,e){t[e]=function(){t.push([e].concat(Array.prototype.slice.call(arguments,0)))}};
          for(var i=0;i<ttq.methods.length;i++)ttq.setAndDefer(ttq,ttq.methods[i]);
          ttq.instance=function(t){
            for(var e=ttq._i[t]||[],n=0;n<ttq.methods.length;n++)ttq.setAndDefer(e,ttq.methods[n]);
            return e
          };
          ttq.load=function(e,n){
            var r="https://analytics.tiktok.com/i18n/pixel/events.js",o=n&&n.partner;
            ttq._i=ttq._i||{},ttq._i[e]=[],ttq._i[e]._u=r,ttq._t=ttq._t||{},ttq._t[e]=+new Date,ttq._o=ttq._o||{},ttq._o[e]=n||{};
            n=document.createElement("script");
            n.type="text/javascript",n.async=!0,n.src=r+"?sdkid="+e+"&lib="+t;
            e=document.getElementsByTagName("script")[0];
            e.parentNode.insertBefore(n,e)
          };
          ttq.load('${pixelId}');
          ttq.page();
        }(window, document, 'ttq');
      `}
    </Script>
  );
}
